
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import Head from 'next/head';
import useTranslation from 'next-translate/useTranslation';
import AffiliateLink from '../components/AffiliateLink';
import RelatedLinks from '../components/RelatedLinks';
import { SITE_URL } from '../lib/site';
// Evergreen EU261 guide with AirHelp affiliate CTAs. Same shape as
// fast-track.js: static facts, FAQ keys drive both the visible FAQ and the
// FAQPage JSON-LD so they stay in sync.
const WHEN_KEYS = ['when_delay', 'when_cancel', 'when_denied'];
const AMOUNT_KEYS = ['amount_short', 'amount_medium', 'amount_long'];
const FAQ_KEYS = ['q1', 'q2', 'q3'];
function CompensationPage() {
    const { t, lang } = useTranslation('compensation');
    const url = lang === 'en'
        ? `${SITE_URL}/en/compensation`
        : `${SITE_URL}/compensation`;
    const faqs = FAQ_KEYS.map((k, i) => ({ q: t(k), a: t(`a${i + 1}`) }));
    const faqJsonLd = {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: faqs.map(({ q, a }) => ({
            '@type': 'Question',
            name: q,
            acceptedAnswer: { '@type': 'Answer', text: a }
        }))
    };
    return (<div className="bg-white p-4 sm:p-6 my-auto rounded max-w-3xl mx-auto text-gray-800">
            <Head>
                <title>{t('meta_title')}</title>
                <meta name="description" content={t('meta_description')}/>
                <meta name="robots" content="all"/>
                <link rel="canonical" href={url}/>
                <meta property="og:title" content={t('meta_title')}/>
                <meta property="og:description" content={t('meta_description')}/>
                <meta property="og:url" content={url}/>
                <script type="application/ld+json" 
    // static/trusted content; escape < so no </script> break-out
    dangerouslySetInnerHTML={{
            __html: JSON.stringify(faqJsonLd).replace(/</g, '\\u003c')
        }}/>
            </Head>

            <h1 className="text-2xl sm:text-3xl font-bold">
                {t('page_title')}
            </h1>
            <p className="mt-3 text-gray-600">{t('intro')}</p>

            <div className="flex">
                <AffiliateLink type="button" text={t('cta')} umamiId="airhelp-cta-top" className="mx-auto my-6"/>
            </div>

            <section className="mt-4">
                <h2 className="text-xl font-semibold">{t('when_title')}</h2>
                <ul className="mt-2 list-disc list-inside text-gray-700 *:my-1">
                    {WHEN_KEYS.map((k) => (<li key={k}>{t(k)}</li>))}
                </ul>
            </section>

            <section className="mt-8">
                <h2 className="text-xl font-semibold">{t('amounts_title')}</h2>
                <ul className="mt-2 list-disc list-inside text-gray-700 *:my-1">
                    {AMOUNT_KEYS.map((k) => (<li key={k}>{t(k)}</li>))}
                </ul>
                <p className="mt-2 text-sm text-gray-600">
                    {t('amounts_note')}
                </p>
            </section>

            <section className="mt-8">
                <h2 className="text-xl font-semibold">
                    {t('exceptions_title')}
                </h2>
                <p className="mt-2 text-gray-700">{t('exceptions_text')}</p>
            </section>

            <section className="mt-8 rounded-lg bg-orange-100 p-4 sm:p-5">
                <h2 className="text-xl font-semibold">{t('how_title')}</h2>
                <p className="mt-2 text-gray-700">{t('how_text')}</p>
                <div className="flex">
                    <AffiliateLink type="button" text={t('cta')} umamiId="airhelp-cta-bottom" className="mx-auto my-4"/>
                </div>
            </section>

            <section className="mt-8">
                <h2 className="text-xl font-semibold">{t('faq_title')}</h2>
                <dl className="mt-4 divide-y divide-gray-200">
                    {faqs.map(({ q, a }, i) => (<div key={i} className="py-4">
                            <dt className="text-lg font-semibold text-gray-900">
                                {q}
                            </dt>
                            <dd className="mt-2 text-gray-700">{a}</dd>
                        </div>))}
                </dl>
            </section>

            <p className="mt-6 text-xs text-gray-500">{t('disclosure')}</p>

            <RelatedLinks links={[
            { href: '/departures', labelKey: 'departures' },
            { href: '/', labelKey: 'security_wait_times' },
            {
                href: '/when-to-arrive',
                labelKey: 'link_when_to_arrive'
            }
        ]}/>
        </div>);
}
export default CompensationPage;

    async function __Next_Translate__getStaticProps__1a1723ec606__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/compensation',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a1723ec606__ as getStaticProps }
  